import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { conversationalWorkflowCacheKeys } from "./constants";
import type { ConversationalWorkflowResult, PostConversationalWorkflowProps } from "./types";

export const postConversationalWorkflow = reactQueryMutationAdapter(
  conversationalWorkflowCacheKeys,
  (props: PostConversationalWorkflowProps): Promise<ConversationalWorkflowResult> => {
    return fetch(`/${props.appGroupId}/conversational/workflow`, "POST", {
      name: props.name,
      purpose: props.purpose,
      steps: props.steps,
      chat_setting: props.chat_setting,
      messaging_channel_setting: props.messaging_channel_setting,
    });
  }
);
